import { Command, Option } from "clipanion";
import { M8tCommand } from "../../lib/m8t-command.js";
import {
  FOUNDRY_CONFIG_KEYS,
  type FoundryConfigKey,
  validateConfigValue,
  writeFoundryConfig,
} from "../../lib/foundry-config.js";
import { LocalCliError } from "../../lib/errors.js";
import { renderJson, resolveOutputMode } from "../../lib/output.js";

export class ConfigSetCommand extends M8tCommand {
  static paths = [["config", "set"]];
  static usage = Command.Usage({
    description: "Set a value in ~/.m8t-stack/config.yaml (tenantId | clientId | projectEndpoint).",
  });

  key = Option.String();
  value = Option.String();
  output = Option.String("--output");

  async executeCommand(): Promise<number> {
    const mode = resolveOutputMode(
      this.output as "pretty" | "json" | "auto" | undefined,
      this.context.stdout as NodeJS.WriteStream,
    );

    if (!(FOUNDRY_CONFIG_KEYS as readonly string[]).includes(this.key)) {
      throw new LocalCliError({
        code: "CONFIG_KEY_UNKNOWN",
        message: `Unknown config key '${this.key}'.`,
        hint: `Valid keys: ${FOUNDRY_CONFIG_KEYS.join(", ")}.`,
      });
    }
    const key = this.key as FoundryConfigKey;
    validateConfigValue(key, this.value);
    await writeFoundryConfig({ [key]: this.value });

    if (mode === "json") {
      this.context.stdout.write(renderJson({ key, value: this.value, written: true }) + "\n");
      return 0;
    }
    this.context.stdout.write(`set ${key} → ${this.value}\n`);
    return 0;
  }
}
